import React from 'react';
import { RegisterForm } from './RegisterForm';
import { Toaster } from '@shared/patterns';

export const RegisterPage: React.FC = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background p-4 pt-[var(--safe-top)] pb-[var(--safe-bottom)]">
      <Toaster position="top-right" richColors />
      <div className="w-full max-w-xl md:max-w-2xl space-y-6 py-8">
        <div className="text-center space-y-2">
          <div className="h-12 w-12 rounded-xl bg-primary text-primary-foreground font-black text-2xl flex items-center justify-center mx-auto shadow-md">
            H
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-foreground">Helios Academy Portal</h1>
          <p className="text-sm text-muted-foreground">Self-Registration & Comprehensive Student Onboarding</p>
        </div>

        <RegisterForm />

        <div className="text-center text-xs text-muted-foreground">
          Protected by Argon2id, Opaque Sessions, & SameSite=Lax Host-Only Cookies.
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
